import { useContext } from 'react';
import '../styles/navbar.css'
import AppContext from '../context/formContext';


const Navbar = () => {
    const {form} = useContext(AppContext)

    return ( 
        <nav className='navbar'>
            <ul className='steps'>
                <li className="step" data-step = {1}><span className={`no ${form === 1 ? 'currentStep' : ''}`}>1 </span><div className="stepDetail"><span className='stepNo'>Step 1</span><span className='stepName'>YOUR INFO</span></div> </li>
                <li className="step" data-step = {2}><span className={`no ${form === 2 ? 'currentStep' : ''}`}>2 </span><div className="stepDetail"><span className='stepNo'>Step 2</span><span className='stepName'>SELECT PLAN</span></div> </li>
                <li className="step" data-step = {3}><span className={`no ${form === 3 ? 'currentStep' : ''}`}>3 </span> <div className="stepDetail"><span className='stepNo'>Step 3</span><span className='stepName'>ADD-ONS</span></div> </li>
                <li className="step" data-step = {4}><span className={`no ${form === 4 ? 'currentStep' : ''}`}>4 </span> <div className="stepDetail"><span className='stepNo'>Step 4</span><span className='stepName'>SUMMARY</span></div> </li>
            </ul>
        </nav>
     );
}
 
export default Navbar;